export default __webpack_public_path__ + "static/media/property_997.5255db56.png";